import { localStorageApi } from '../api/local-storage-api';

type OrgUrlParams = {
  organizationCode?: string;
  locationCode?: string;
  departmentCode?: string;
  workflow?: string;
  visitId?: string;
  worksheetId?: string;
  activity?: string;
  worksheetTypes?: string[];
};

export function getOrgUrlParams(): OrgUrlParams {
  const params = new URLSearchParams(window.location.search);
  const organizationCode = params.get('org');
  const locationCode = params.get('loc');
  const departmentCode = params.get('dep');
  const workflow = params.get('wor');
  const visitId = params.get('vis');
  const worksheetId = params.get('wid');
  const activity = params.get('act');
  const worksheetTypes = (params.get('wts') || '').split('.');
  
  return {
    organizationCode,
    locationCode,
    departmentCode,
    workflow,
    visitId,
    activity,
    worksheetId,
    worksheetTypes,
  };
}

const key = 'org';
const store = localStorageApi();

export function getStoredOrgUrlParams(): OrgUrlParams {
  const url = getOrgUrlParams();
  if (url.organizationCode && url.locationCode && url.departmentCode) {
    store.setItem(key, { value: url });
    return url;
  }
  const params = localStorageApi().getItem<OrgUrlParams>(key);
  return { ...url, ...params.value };
}
